/**
* @author XuZiYu
* @date 2019/8/30
* @time 09:53
*/
<template>
  <div class="open-warp">
    <div class="header" :style="{marginTop: headHeight + 'px'}">
      <div class="header-left" v-if="!$route.query.shareType && $route.query.headShow !== '0'" @click="goBack"><img
          src="../../../assets/vip/icon_back@2x.png" alt=""/></div>
      <div class="header-main" v-if="!$route.query.shareType && $route.query.headShow !== '0'">VIP题库</div>
      <div class="header-share" v-if="(!$route.query.shareType && $route.query.headShow !== '0') && isShowShareIcon"
           @click="openSharePanel"><img src="@/assets/public/icon_fx02.png" alt=""></div>
      <div class="header-right" v-if="!$route.query.shareType && $route.query.headShow !== '0'" @click="callPhone"><img
          src="../../../assets/vip/icon_customerservice@2x.png" alt=""></div>
    </div>
    <share-ad :detail="adInfo">
      <div class="user-info">
        <div class="user-info-left">
          <div class="user-img">
            <img v-if="userInfo.logoUrl" :src="userInfo.logoUrl" alt=""/>
            <img v-else src="../../../assets/vip/default-user-img.png" alt=""/>
          </div>
        </div>
        <div class="user-info-right">
          <div class="user-name"><span>{{userInfo.petName}}</span><img src="../../../assets/vip/icon_viplabel@2x.png"
                                                                       alt=""/></div>
          <div class="user-use-time">有效期至{{vipData.effectiveDate}}</div>
        </div>
      </div>
      <div class="menu">
        <div class="menu-title">VIP题库服务</div>
        <div class="nav">
          {{dictionary.subject[subject]}}
          <span class="nav-button" @click="changeSubject">切换</span>
        </div>
      </div>
      <div class="banner" @click="goPushFeaturedPage">
        <div class="banner-left">
          <div class="banner-left-top">
            <span><b>精选</b>500题</span>
            <span>{{dictionary.subject[subject]}}</span>
          </div>
          <div class="banner-left-bottom">
            精选500题，快速掌握全部考点
          </div>
        </div>
        <div class="banner-right">
          <img src="../../../assets/vip/icon_pageturning@2x.png" alt="">
        </div>
      </div>
      <div class="item-warp">
        <div class="item">
          <div class="item-left">
            <img src="../../../assets/vip/icon_problem1@2x.png" alt="">
          </div>
          <div class="item-main">
            <div class="item-main-top">难题攻克</div>
            <div class="item-main-bottom">挑选100道考试难点突击</div>
          </div>
          <div class="item-right" @click="goPushProblemPage">
            <div class="item-button">去做题</div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            <img src="../../../assets/vip/icon_error@2x.png" alt="">
          </div>
          <div class="item-main">
            <div class="item-main-top">易错题集</div>
            <div class="item-main-bottom">筛选100道考生最容易做错的题</div>
          </div>
          <div class="item-right" @click="goPushErrorPronePage">
            <div class="item-button">去做题</div>
          </div>
        </div>
        <div class="item">
          <div class="item-left">
            <img src="../../../assets/vip/icon_forecast@2x.png" alt="">
          </div>
          <div class="item-main">
            <div class="item-main-top">预测通过率</div>
            <div class="item-main-bottom">100%还原试卷难度，预测考试通过率</div>
          </div>
          <div class="item-right" @click="goPushExamPassRatePage">
            <div class="item-button">去预测</div>
          </div>
        </div>
      </div>
      <div class="rule">
        <div class="rule-title">
          <img class="rule-icon-left" src="../../../assets/vip/icon_line1@2x.png" alt=""/>
          <span>服务说明</span>
          <img class="rule-icon-right" src="../../../assets/vip/icon_line2@2x.png" alt=""/>
        </div>
        <p class="rule-content">1. 感谢您购买了VIP题库，有效期至{{vipData.effectiveDate}}
          2. VIP题库为虚拟产品，不支持退款。
          3. 费用仅包含VIP题库，不包含其他保障险。
          4. 如有疑问，请联系{{vipData.phone}}。</p>
      </div>
    </share-ad>
  </div>
</template>

<script>
export default {
    name: 'open',
    props: ['vipData', 'userInfo'],
    methods: {
        // 返回
        goBack () {
            window.app.returnLastPage && window.app.returnLastPage()
        },
        // 切换题库
        changeSubject () {
            if (this.isGoApp()) {
                return
            }
            this.subject = this.subject === 1 ? 4 : 1
        },
        isGoApp () {
            // 判断是否h5
            if (this.$route.query.shareType === 'h5') {
                let isIos = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
                if (isIos) {
                    if (Number(this.$route.query.appType) === 2) {
                        location.href = 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    } else {
                        location.href = 'https://share.banbanjiadao.com/ui/h5/bb/index'
                    }
                } else {
                    if (Number(this.$route.query.appType) === 2) {
                        location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    } else {
                        location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
                    }
                }
                return true
            }
            return false
        },
        // 拨打客服电话
        callPhone () {
            if (this.isGoApp()) {
                return
            }
            window.app.pushCusService && window.app.pushCusService()
        },
        // 进入精选500题页面
        goPushFeaturedPage () {
            if (this.isGoApp()) {
                return
            }
            window.app.pushFeaturedPage && window.app.pushFeaturedPage(parseInt(this.subject))
        },
        // 进入难题攻克题页面
        goPushProblemPage () {
            if (this.isGoApp()) {
                return
            }
            window.app.pushProblemPage && window.app.pushProblemPage(parseInt(this.subject))
        },
        // 进入易错题页面
        goPushErrorPronePage () {
            if (this.isGoApp()) {
                return
            }
            window.app.pushErrorPronePage && window.app.pushErrorPronePage(parseInt(this.subject))
        },
        // 进入考试通过率页面
        goPushExamPassRatePage () {
            if (this.isGoApp()) {
                return
            }
            if (this.userInfo.userId) {
                window.app.pushExamPassRatePage && window.app.pushExamPassRatePage(parseInt(this.subject))
            } else {
                window.app.loginUser && window.app.loginUser()
            }
        },
        openSharePanel () {
            window.app.share && window.app.share(this.adInfo.shareTitle || 'VIP题库', '掌握一题=练习多题，轻松搞定科一&科四！', this.adInfo.shareType === '1' ? location.href.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn') + '&shareType=h5' + `&appType=${window.app.getAppType && window.app.getAppType()}` : '', this.adInfo.shareType === '1' ? (this.adInfo.shareImg || 'http://app.static.public.chetailian.com/share/VIPtk.png') : this.adInfo.shareGroupImg, 'question-bank')
        },
        // 获取分享配置信息
        getSetting () {
            this.$api.getAdSetting({ code: 'question-bank' }).then(res => {
                if (res.status && res.result) {
                    this.adInfo = res.result
                    this.isShowShareIcon = this.$route.query.shareType !== 'h5' && window.app.shareParams
                }
            })
        }
    },
    mounted () {
        this.getSetting()
    },
    data () {
        return {
            dictionary: {
                subject: {
                    1: '科目一',
                    4: '科目四'
                }
            },
            adInfo: {},
            isShowShareIcon: false,
            headHeight: 0,
            subject: 1
        }
    },
    created () {
        this.subject = this.$route.query.subject || 1
    }
}
</script>

<style lang="scss">
  @function vw($px) {
    @return ($px / 750) * 100vw;
  }

  .open-warp {
    overflow: auto;
    background: url("../../../assets/vip/picture_vipbg@2x.png") #ffffff no-repeat;
    background-size: 100%;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: vw(140);
      padding-top: 10px;

      .header-main {
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
      }

      .header-share {
        position: absolute;
        height: 60px;
        display: flex;
        align-items: center;
        right: 50px;
        font-size: 0;
        line-height: 1;

        img {
          width: 24px;
        }
      }

      .header-left, .header-right {
        display: flex;
        font-size: 0;
        padding: 15px 10px;
        line-height: 1;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }

    .user-info {
      width: vw(690);
      height: 100px;
      background: url("../../../assets/vip/picture_information@2x.png") center center no-repeat;
      background-size: 100%;
      margin: vw(45) auto 0;
      display: flex;
      align-items: center;

      .user-info-left {
        padding: 0 15px;

        .user-img {
          width: 60px;
          height: 60px;
          border-radius: 100%;
          border: 2px solid #ffffff;
          overflow: hidden;

          img {
            width: 60px;
          }
        }
      }

      .user-info-right {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .user-name {
          font-size: 18px;
          font-family: PingFangSC;
          font-weight: 600;
          color: #333333;
          display: flex;
          align-items: center;

          span {
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          img {
            margin-left: 7px;
            width: vw(68);
          }
        }

        .user-use-time {
          margin-top: 12px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: #A86F2F;
        }
      }
    }

    .menu {
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
      margin-top: 25px;

      .menu-title {
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: 600;
        color: #333333;
      }

      .nav {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);

        .nav-button {
          margin-left: 7.5px;
          padding: 0 5px;
          border-radius: vw(18);
          border: 1px solid rgba(200, 160, 106, 1);
          font-size: 13px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(200, 160, 106, 1);
        }
      }
    }

    .banner {
      width: vw(690);
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      box-sizing: border-box;
      margin: 20px auto 0;
      background: url("../../../assets/vip/picture_500topic@2x.png") no-repeat;
      background-size: 100%;

      .banner-left {
        .banner-left-top {
          display: flex;
          align-items: center;
          font-size: 0;
          line-height: 1;

          span:nth-child(1) {
            display: flex;
            align-items: center;
            font-size: 15px;
            font-family: PingFangSC;
            font-weight: 600;
            color: #603F20;

            b {
              color: #FF5050;
            }
          }

          span:nth-child(2) {
            display: inline-block;
            width: vw(126);
            height: 18px;
            line-height: 18px;
            text-align: center;
            background: url("../../../assets/vip/icon_subjectlabel@2x.png") no-repeat;
            background-size: 100%;
            margin-left: 5px;
            font-size: 13px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }

        .banner-left-bottom {
          margin-top: 7.5px;
          font-size: 13px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(147, 132, 103, 1);
        }
      }

      .banner-right {
        font-size: 0;
        line-height: 1;

        img {
          width: 12px;
        }
      }
    }

    .item-warp {
      padding: 0 15px;

      .item {
        padding: vw(46) 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #EEEEEE;

        &:last-child {
          border-bottom: none;
        }

        .item-left {
          img {
            width: vw(64);
          }
        }

        .item-main {
          display: flex;
          flex: 1;
          margin-left: vw(22);
          flex-direction: column;
          justify-content: center;

          .item-main-top {
            font-size: 15px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }

          .item-main-bottom {
            margin-top: 2.5px;
            font-size: 13px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
          }
        }

        .item-right {
          .item-button {
            padding: 2.5px 7.5px;
            border-radius: 16px;
            border: 1px solid rgba(200, 160, 106, 1);
            font-size: 13px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(200, 160, 106, 1);
          }
        }
      }
    }

    .rule {
      padding-bottom: 25px;

      .rule-title {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333333;
        font-size: 15px;
        font-family: PingFangSC;
        font-weight: 600;
        padding: 15px 0;

        span {
          margin: 0 20px;
        }

        img {
          width: 15px;
        }
      }

      .rule-content {
        padding: 0 15px;
        font-size: 13px;
        font-family: PingFangSC;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        word-break: break-word;
        white-space: pre-line;

        b {
          color: #FF5050;
          font-weight: normal;
        }
      }
    }
  }
</style>
